import React from 'react';
import * as LucideIcons from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useAppContext } from '../AppContext';

const MyQRCodeModal = ({ onClose }) => {
    const { t } = useTranslation();
    const { userId, currentUserProfile } = useAppContext();

    if (!userId || !currentUserProfile) return null;

    const qrData = JSON.stringify({ type: 'user_profile', userId: userId });
    const qrUrl = `https://api.qrserver.com/v1/create-qr-code/?size=256x256&data=${encodeURIComponent(qrData)}&bgcolor=0d1117`;

    return (
        <div className="fixed inset-0 bg-black/60 z-50 flex justify-center items-center animate-fadeIn a-short-delay" onClick={onClose}>
            <div className="bg-gray-800 rounded-xl shadow-lg w-full max-w-sm m-4 border border-gray-700" onClick={(e) => e.stopPropagation()}>
                <div className="p-6 border-b border-gray-700 flex justify-between items-center">
                    <h2 className="text-xl font-bold text-white">{t('myQRCodeModal.title')}</h2>
                    <button onClick={onClose} className="ai-icon-button text-gray-400 hover:bg-white/10">
                        <LucideIcons.X size={24} />
                    </button>
                </div>
                <div className="p-8 flex flex-col items-center justify-center">
                    <div className="p-4 bg-white rounded-lg">
                        <img src={qrUrl} alt={t('myQRCodeModal.altText')} width="256" height="256" />
                    </div>
                    <p className="text-gray-400 text-center mt-4 text-sm">{t('myQRCodeModal.description')}</p>
                </div>
            </div>
        </div>
    );
};

export default MyQRCodeModal;
